import pluralize from 'pluralize';

import DragType from '~/components/Shared/Drag/dragTypes';

type ReactDndDragItemsCountProps = {
  type: DragType;
  mixedTypes: boolean;
  count: number;
};

export const ReactDndDragItemsCount = ({ count, mixedTypes, type }: ReactDndDragItemsCountProps) => {
  const countText = () => {
    let itemsText = '';

    if (mixedTypes) {
      itemsText = 'item';
    } else {
      switch (type) {
        case DragType.boardNavFavorites:
        case DragType.boardNavWorkspace:
        case DragType.boardNavLibrary:
        case DragType.boardCard:
          itemsText = 'board';
          break;
        case DragType.asset:
          itemsText = 'asset';
          break;
        case DragType.file:
          itemsText = 'file';
          break;
      }
    }

    return pluralize(itemsText, count, true);
  };

  return (
    <div className="flex h-6 items-center rounded-4 bg-black/70 px-1.5">
      <span className="font-semibold text-12 text-white">{countText()}</span>
    </div>
  );
};
